/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

interface ISeparator {
    separator: string;
}

export const Separator: React.FC<ISeparator> = ({ separator }) => (
    <span aria-hidden='true'>
        {` `}
        {separator}
        {` `}
    </span>
);
